import type { BlockSectionBg } from "./types";
import { getSectionGridCellClass, getSectionGridRowFillerCount } from "../blockSection";
import { cn } from "@/lib/utils";

interface SectionGridRowFillersProps {
  itemsCount: number;
  desktopColumns: number;
  tabletItemsCount?: number;
  sectionBg?: BlockSectionBg;
}

const TABLET_COLUMNS = 2;

/** Fills incomplete last rows so gap-px shell bg-border does not show as grey holes. */
export function SectionGridRowFillers({
  itemsCount,
  desktopColumns,
  tabletItemsCount,
  sectionBg = "light",
}: SectionGridRowFillersProps) {
  const cellClass = getSectionGridCellClass(sectionBg);
  const tabletFillers = getSectionGridRowFillerCount(
    tabletItemsCount ?? itemsCount,
    TABLET_COLUMNS
  );
  const desktopFillers = getSectionGridRowFillerCount(itemsCount, desktopColumns);

  if (tabletFillers === 0 && desktopFillers === 0) return null;

  return (
    <>
      {Array.from({ length: tabletFillers }).map((_, index) => (
        <div
          key={`grid-filler-tablet-${index}`}
          className={cn(cellClass, "hidden md:block desktop:hidden")}
          aria-hidden
        />
      ))}
      {Array.from({ length: desktopFillers }).map((_, index) => (
        <div
          key={`grid-filler-desktop-${index}`}
          className={cn(cellClass, "hidden desktop:block")}
          aria-hidden
        />
      ))}
    </>
  );
}
